// Module
var code = "<div class=\"well\"> <kform-builder-list component=\"component\" form=\"form\" options=\"options\"></kform-builder-list> </div> ";
// Exports
export default code;